import React from 'react';

import './services.scss';
import {Page} from '../../../clean-components/page/page';
import ServicesOperatorsComponent from '../../../clean-components/services-operators/services-operators';


export function Services() {
    return <>
        <Page title="translation:misc_services_operators_title">
            <ServicesOperatorsComponent/>
        </Page>
    </>;
}
